import DocLinkLabel from '@components/sources/docLinksLabel';
import InfoPopover from '@ui-library/infoPopover';
import React from 'react';
import { WAREHOUSE_DOC_LINKS } from '../../warehouseSource/warehouseSourceList/warehouseSettings';

const ScheduleSettingsInfo: React.FC = () => (
  <InfoPopover
    content={
      <DocLinkLabel
        insidePopover
        description="For more info click"
        linkRef={WAREHOUSE_DOC_LINKS.syncScheduleSettings}
      />
    }
    size="l"
  />
);

export default ScheduleSettingsInfo;
